"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buttonWithDigitalHig = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@mui/material/Button"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Adapts Digital HIG layout prop to a Material UI fullWidth prop
 */
var adaptLayoutProp = function adaptLayoutProp(layoutProp) {
  return layoutProp === _constants.layouts.STRETCH;
};
/**
 * Adapts Digital HIG size prop to a Material UI size prop
 */


var adaptSizeProp = function adaptSizeProp(sizeProp) {
  return sizeProp === _constants.sizes.DENSE ? "small" : "medium";
};
/**
 * Adapts a Digital HIG props to Material UI sizes
 */


var adaptProps = function adaptProps(_ref) {
  var layout = _ref.layout,
      size = _ref.size,
      otherProps = _objectWithoutProperties(_ref, ["layout", "size"]);

  // Prioritizes layout but supports Material UI fullWidth
  var muiFullWidth = adaptLayoutProp(layout) || otherProps.fullWidth;
  var muiSize = adaptSizeProp(size);
  return _objectSpread(_objectSpread({}, otherProps), {}, {
    fullWidth: muiFullWidth,
    size: muiSize
  });
};
/**
 * Makes a Digital HIG button component using the provided MUIButton as base
 */


var buttonWithDigitalHig = function buttonWithDigitalHig(BaseMuiButton) {
  var Button = /*#__PURE__*/_react.default.forwardRef(function (_ref2, ref) {
    var children = _ref2.children,
        className = _ref2.className,
        otherProps = _objectWithoutProperties(_ref2, ["children", "className"]);

    // https://mui.com/api/button/
    // List out complete MUI API props and fillout values for props that will be
    // preset in the component; all the others will be received from the parent
    var muiButtonApiPresets = {
      // children,
      // classes,
      // color,
      // component,
      // disabled,
      // disableElevation (already disabled at theme level)
      // disableFocusRipple (already disabled at theme level)
      disableRipple: true // endIcon,
      // fullWidth,
      // href,
      // size,
      // startIcon,
      // sx
      // variant

    };
    var classnames = className && className.split(" ") || [];
    var adaptedProps = adaptProps(otherProps);
    return /*#__PURE__*/_react.default.createElement(BaseMuiButton, _extends({}, muiButtonApiPresets, adaptedProps, {
      ref: ref,
      className: classnames.join(" ")
    }), children);
  });

  Button.displayName = "Button";
  Button.defaultProps = {
    disabled: false,
    layout: _constants.layouts.HUG,
    size: _constants.sizes.DEFAULT,
    variant: _constants.variants.CONTAINED
  };
  Button.propTypes = {
    className: _propTypes.default.string,
    children: _propTypes.default.node.isRequired,
    disabled: _propTypes.default.bool,
    layout: _propTypes.default.oneOf(_constants.availableLayouts),
    size: _propTypes.default.oneOf(_constants.availableSizes),
    variant: _propTypes.default.oneOf(_constants.availableVariants)
  };
  return Button;
};

exports.buttonWithDigitalHig = buttonWithDigitalHig;
var Button = buttonWithDigitalHig(_Button.default);
var _default = Button;
exports.default = _default;